import enLang from './entries/en-US';
import idLang from './entries/id_ID';

const AppLocale = {
  id: idLang,
  en: enLang,
};

export default AppLocale;
